export default  {"src":"/_next/static/image/public/images/id-card_dark.f5b4b4aef7a8feb7dd47e8b6db83f042.svg","height":26,"width":20};